/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Components
import Gamehero from '../../components/heros/game.js';
import Footer from '../../components/footer.js';
import Button from '../../components/buttons/primary.js';
import DDoSProtection from '../../components/sections/ddosProtection';
import Location from '../../components/sections/location';
import Features from '../../components/sections/features.js';
import CyperPanel from '../../components/sections/cyperpanel.js';
import Reviews from '../../components/sections/reviews';

const Discord = () => {
    return (
        <main>
            <Gamehero title="Discord Bot Hosting" description="Powerful and intuitive easy to use Discord Bot hosting. We don't overcomplicate things. It just works." />
            <div className='plans max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-28'>
                <div className="header mb-24">
                    <h1 className="text-gray-100 text-center text-3xl font-semibold">Discord Hosting Plans</h1>
                </div>
                <div className='body'>
                    <div className="popular-plans bg-primaryDark rounded-lg px-1.5 mb-6">
                        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3">
                            <div className="hosting-plan px-9 py-12" id="starter_plan">
                                <div className="plan-info mb-8">
                                    <h1 className="text-gray-300 font-semibold text-xl text-center mb-5">Starter Plan</h1>
                                    <p className="text-gray-100 font-bold text-2xl text-center">512MB</p>
                                </div>
                                <div className="plan-specs mb-9">
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">CPU</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">Intel Xeon E5 1650v4</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Ram</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">512MB</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Storage</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">5GB</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <div>
                                            <h1 className="text-gray-400">DDoS Protection</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="plan-order flex justify-center">
                                    <Button title="Choose Plan" />
                                </div>
                            </div>
                            <div className="hosting-plan px-9 py-12 secondary-gradient border-t-4 border-primary" id="personal_plan">
                                <div className="plan-info mb-8">
                                    <h1 className="text-gray-300 font-semibold text-xl text-center mb-5">Personal Plan</h1>
                                    <p className="text-gray-100 font-bold text-2xl text-center">2GB</p>
                                </div>
                                <div className="plan-specs mb-9">
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">CPU</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">Intel Xeon E5 1650v4</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Ram</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">2GB</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Storage</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">10GB</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <div>
                                            <h1 className="text-gray-400">DDoS Protection</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="plan-order flex justify-center">
                                    <Button title="Choose Plan" />
                                </div>
                            </div>
                            <div className="hosting-plan no-border px-9 py-12" id="enterprise_plan">
                                <div className="plan-info mb-8">
                                    <h1 className="text-gray-300 font-semibold text-xl text-center mb-5">Enterprise Plan</h1>
                                    <p className="text-gray-100 font-bold text-2xl text-center">4GB</p>
                                </div>
                                <div className="plan-specs mb-9">
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">CPU</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">Intel Xeon E5 1650v4</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Ram</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">4GB</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-2.5">
                                        <div>
                                            <h1 className="text-gray-400">Storage</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">15GB</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center">
                                        <div>
                                            <h1 className="text-gray-400">DDoS Protection</h1>
                                        </div>
                                        <div className="ml-auto">
                                            <p className="text-gray-100 font-semibold">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="plan-order flex justify-center">
                                    <Button title="Choose Plan" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Features />
            <CyperPanel />
            <DDoSProtection />
            <Location />
            <Reviews />
            <Footer />
        </main>
    )
}

export default Discord